// extracted by mini-css-extract-plugin
var _1 = "contentBlock__zTP9e";
var _2 = "item__HQ0Ks";
var _3 = "number__T6I_1";
var _4 = "subtitle__Qv5cP";
var _5 = "title__uBtVY";
var _6 = "titleWrapper__ngIjt";
export { _1 as "contentBlock", _2 as "item", _3 as "number", _4 as "subtitle", _5 as "title", _6 as "titleWrapper" }
export default { "contentBlock": _1, "item": _2, "number": _3, "subtitle": _4, "title": _5, "titleWrapper": _6 }
